import { useState } from 'react';
import { Text, Button } from '@chakra-ui/react';
import { useActions } from '../../redux/store';
import { useCanUpdateInput } from './Input';

type CounterProps = {
  value?: number;
  min?: number;
  max?: number;
  isDisabled?: boolean;
  needUpdate?: boolean;
  f: any;
  handleOnChange?: (value: number) => void;
};

const Counter = ({
  value = 0,
  min = 0,
  max = Number.POSITIVE_INFINITY,
  isDisabled,
  needUpdate,
  handleOnChange,
  f,
}: CounterProps) => {
  const [val, setVal] = useState<number>(value);

  const { getData } = useActions();
  const canUpdateInput = useCanUpdateInput();

  const canUpdate = canUpdateInput(f.name_id);

  const setSafe = (next: number) => {
    if (next < min || next > max) return;

    setVal(next);
    handleOnChange?.(next);

    if (needUpdate) {
      getData({ noRefresh: true });
    }
  };

  const disabled = isDisabled || !canUpdate;

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
      {!disabled && (
        <Button size='xs' onClick={() => setSafe(val - 1)}>
          −
        </Button>
      )}

      <Text>{val}</Text>

      {!disabled && (
        <Button size='xs' onClick={() => setSafe(val + 1)}>
          +
        </Button>
      )}
    </div>
  );
};

export default Counter;
